import React from "react";
import { Tag } from "antd";
import { fetchJsData } from "../../../../api";
import { isArray } from "lodash";

export const newApps = (leng) => {
  return [
    {
      title: () => {
        return (
          <>
            App Name/Domain <Tag color="processing">{leng}</Tag>
          </>
        );
      },
      dataIndex: "app_name",
      key: "app_name",
      fixed: "left",
      sorter: (a, b) => (a.app_name ? a.app_name.localeCompare(b.app_name) : 1),
      // responsive: ["sm"],
      width: "30%",
    },
    {
      title: "Old Category",
      dataIndex: "old_category",
      key: "old_category",
      fixed: "left",
      sorter: (a, b) =>
        a.old_category ? a.old_category.localeCompare(b.old_category) : 1,
      // responsive: ["sm"],
      width: "20%",
    },
    {
      title: "New Category",
      dataIndex: "current_category",
      key: "current_category",
      fixed: "left",
      sorter: (a, b) =>
        a.current_category
          ? a.current_category.localeCompare(b.current_category)
          : 1,
      // responsive: ["sm"],
      width: "20%",
    },
    {
      title: "Release",
      dataIndex: "release_name",
      key: "release_name",
      fixed: "left",
      // responsive: ["sm"],
      width: "30%",
      ellipsis: true,
      render: (text) => {
        return <>{isArray(text) ? text.join(", ") : text}</>;
      },
    },
  ];
};

export const fetchUserSearch = async (data) => {
  try {
    const start = Date.now();

    // const millis = Date.now() - start;
    console.log(`data fetched = ${Math.floor((Date.now() - start) / 1000)}`);

    // const data = await fetchJsData({
    //   type: "fetch",
    //   qry: "fetBulkCatUpdate",
    // });

    console.log(`data fetched = ${Math.floor((Date.now() - start) / 1000)}`);

    return { success: 1, data: data.length ? data : [] };
  } catch (error) {
    console.error(error);
    return "";
  }
};

export const tabPageCss = {
  padding: "0",
  marginBottom: "0",
};

export const cardCss = { padding: "0", borderStyle: "hidden" };
